import { useMutation } from "@shared/lib/hooks";
import { BriefConfigService } from "../../services/briefConfigService";
import { ToastService } from "@shared/lib/services";
import { IFieldConfig } from "@shared/lib/types/briefInfluencerV2";
import { BRIEF_CAMPAIGN_DATA_FIELDS_QUERY_KEY } from "../../constants";
import { BRIEF_CAMPAIGNS_LIST_QUERY_KEY } from "@entities/campaigns/lib/contsants";

interface ICreateBriefDataFieldsRequest {
  briefId: string;
  operationsCustomFieldsV2: IFieldConfig;
}

export function useCreateBriefCampaignDataFields(briefId: string) {
  const {
    mutate: createCampaignDataFields,
    isLoading: isCreating,
    isSuccess: isCreated,
  } = useMutation({
    mutationFn: (data: ICreateBriefDataFieldsRequest) =>
      BriefConfigService.createBriefCampaignDataFieldsV2(
        data.briefId,
        data.operationsCustomFieldsV2
      ).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: {},
    onSuccess: (c) => {
      c.invalidateQueries({
        queryKey: [...BRIEF_CAMPAIGNS_LIST_QUERY_KEY(briefId)],
      });
      c.invalidateQueries({
        queryKey: [...BRIEF_CAMPAIGN_DATA_FIELDS_QUERY_KEY, briefId],
      });
    },
  });

  return {
    createCampaignDataFields,
    isCreating,
    isCreated,
  };
}
